/* eslint-disable no-console */
import * as Scrivito from "scrivito";

import { jsonLd } from "^/Widgets/SchemaWidget/Schemas";
import { SchemaWidgetComponent } from "^/Widgets/SchemaWidget/SchemaWidgetComponent";
import PersonAvatar from "./PersonAvatar";

function ContactWidget({ widget }) {
  const contactPage = widget.get("contactPage");
  const aspectRatio = widget.get("aspectRatio") || "1_1";
  const direction = widget.get("direction") || "row";
  const showSchema = widget.get("showSchema");

  const json = jsonLd.ContactPoint(widget, contactPage);

  if (!contactPage && Scrivito.isInPlaceEditingActive()) {
    return (
      <div className="alert alert-danger">Please select a contact person.</div>
    );
  }

  if (!contactPage) {
    return null;
  }

  const phone =
    contactPage.get("altPhoneNumber") || contactPage.get("phoneNumber");

  const whichEmailAddress = widget.get("whichEmailAddress");
  let email = contactPage.get("email");
  if (whichEmailAddress === "primary") {
    email = contactPage.get("email");
  }
  if (whichEmailAddress === "secondary") {
    const altEmail = contactPage.get("altEmail");
    if (altEmail) {
      email = altEmail;
    }
  }
  if (whichEmailAddress === "fromThisWidget") {
    email = widget.get("emailAddressToShow");
  }
  if (!whichEmailAddress) {
    email =
      widget.get("isAltEmailDisplayed") === "yes"
        ? contactPage.get("altEmail")
        : contactPage.get("email");
  }

  return (
    <>
      <div className={`contact-widget --flex-${direction} mb-3`}>
        <PersonAvatar widget={widget} aspectRatio={aspectRatio} />
        <div className="contact-widget-content">
          <Scrivito.LinkTag
            to={contactPage}
            className="contact-widget-content__name"
          >
            {contactPage.get("title")}
          </Scrivito.LinkTag>
          <Scrivito.ContentTag
            content={widget}
            attribute="contactReason"
            className="contact-widget__reason"
          />

          <div className="mt-3">
            {phone && (
              <a
                className="contact-widget-content__phone d-block"
                target="_top"
                href={`tel:${phone.replace(/\s/g, "")}`}
              >
                <span className="key">{phone}</span>
              </a>
            )}
            {email && (
              <a
                className="contact-widget-content__email d-block"
                target="_top"
                href={`mailto:${email}`}
              >
                <span className="key">{email}</span>
              </a>
            )}
          </div>
        </div>
      </div>
      {showSchema && <SchemaWidgetComponent type="ContactPoint" json={json} />}
    </>
  );
}

Scrivito.provideComponent("ContactWidget", Scrivito.connect(ContactWidget));
